import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function Security() {
  const { isEmailVerified, isMfaEnrolled, mfaEnrolledFactorLabel, user } = useAuth();

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <div className="rounded-full bg-blue-100 dark:bg-blue-950/40 p-3">
          <ShieldCheck className="w-6 h-6 text-blue-600 dark:text-blue-300" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Security</h1>
          <p className="text-gray-600 dark:text-gray-300">
            Review the sign-in protections currently enforced for your dashboard account.
          </p>
        </div>
      </div>

      <section className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 space-y-6">
        <div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Account status</h2>
          <p className="text-sm text-gray-600 dark:text-gray-300 mt-1">
            This dashboard requires a verified email address and a TOTP authenticator app.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <div className="rounded-lg border border-gray-200 dark:border-gray-700 p-4">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Email</p>
            <p className="mt-1 break-all text-gray-900 dark:text-white">{user?.email ?? 'Unknown email'}</p>
            <span className={`mt-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${isEmailVerified ? 'bg-green-100 text-green-800 dark:bg-green-950/30 dark:text-green-300' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950/30 dark:text-yellow-300'}`}>
              {isEmailVerified ? 'Verified' : 'Not verified'}
            </span>
          </div>

          <div className="rounded-lg border border-gray-200 dark:border-gray-700 p-4">
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Multi-factor authentication</p>
            <p className="mt-1 text-gray-900 dark:text-white">
              {isMfaEnrolled ? (mfaEnrolledFactorLabel ?? 'Authenticator app') : 'Not enrolled'}
            </p>
            <span className={`mt-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${isMfaEnrolled ? 'bg-green-100 text-green-800 dark:bg-green-950/30 dark:text-green-300' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950/30 dark:text-yellow-300'}`}>
              {isMfaEnrolled ? 'Required factor active' : 'Missing second factor'}
            </span>
          </div>
        </div>

        <div className="rounded-md bg-gray-50 dark:bg-gray-900 p-4 text-sm text-gray-600 dark:text-gray-300">
          If you lose access to your authenticator app, reset the factor in Firebase Console before signing in again.
          This frontend keeps the security view read-only to avoid accidental lockouts.
        </div>
      </section>
    </div>
  );
}
